/*

FILE: events.js
DESCRIPTION: Handle events throughout site
AUTHOR(S): R.J. LaCount / Nick Katarow

*/

import { elements } from './elements.js';
import initOnResize from './resize.js';
import { debounce } from './utils.js';
import linkClicked from './links.js';

const clickHandlers = (e) => {
    const { target } = e;
    if (Array.from(elements.links).includes(target)) linkClicked(e);
};

const resizeHandlers = debounce(() => {
    initOnResize();
}, 300, true);

const setEventHandlers = () => {
    document.addEventListener('click', clickHandlers);
    window.addEventListener('resize', resizeHandlers);
};

const removeEventHandlers = () => {
    document.removeEventListener('click', clickHandlers);
    window.removeEventListener('resize', resizeHandlers);
};

export { setEventHandlers, removeEventHandlers };
